export default "__VITE_ASSET__Dpism_Nv__"